<template>
  <div class="b_nav" >
      <Menu mode="horizontal" :theme="theme1" active-name="1" class="nav" v-if='$store.state.width<768?false:true'>
      <MenuItem name="1" to="/">
        首页
      </MenuItem>
      <MenuItem name="2" to="/technical/1">
        技术服务
      </MenuItem>
      <MenuItem name="3" to="/products/1">
        产品展示
      </MenuItem>
      <MenuItem name="4" to="/solution/1">
        解决方案
      </MenuItem>
      <Submenu name="5">
        <template slot="title">
          关于我们
        </template>
        <MenuItem name="5-1" to="/intros/1">企业简介</MenuItem>
        <MenuItem name="5-2" to="/contact-info">联系我们</MenuItem>
      </Submenu>
    </Menu>
    <!-- 更多 -->
    <div v-if='$store.state.width<768?true:false'>
      <div 
        class='more'
        @click="value1 = true">
        <Icon type="ios-list" size="40" color="#FFF" />  导航栏     
      </div>
      <Drawer :title="title" :closable="false" v-model="value1">
        <Aside />
      </Drawer>
    </div>
      
  </div>
</template>
<script>
import Aside from '@/components/index/components/aside'
export default {
  name: 'Navigation',
  components: {   
    Aside
  },
  data () {
    return {
      theme1: 'primary',
      value1: false,
      title: "导 航 菜  单"
    }
  },
  /*methods: {
    $_more() {
      let arr = [];
      arr.splice(0, 1);
      this.$emit('AsideShow', arr);
      arr = null;
    }
  }*/
}
</script>
<style scoped>
  .b_nav {
    background: #2F669A;
    width: 100%;
  }
  .nav {
    margin: 0 auto;
  }
  .ivu-menu-primary {
    background: #2F669A;
  }
  .ivu-menu-horizontal {
    height: 80px;
    font-size: 16px;
  }
  .ivu-menu-submenu {
    height: 80px;
    line-height: 80px;
    padding: 0px 50px;
  }
  .ivu-menu-item {
    height: 80px;
    line-height: 80px;
    padding: 0px 50px;
    font-size: 16px;
  }
  .ivu-menu-item:hover {
    background: #0099CC;
  }
  .ivu-menu-submenu:hover {
    background: #0099CC;
  }
  .ivu-menu-submenu div:hover {
    background: #0099CC;
  }
  @media screen and (max-width:3840px) {
    .nav {
      width: 1200px;
    }
  }
  @media screen and (max-width:1200px) {
    .nav {
      width: 960px;
    }
  }
  @media screen and (max-width:960px) {
    .nav {
      width: 768px;
    }
  }
  .more {
    width:100%;
    height:100%;
    line-height:60px;
    text-align:center;
    cursor:pointer;
  }
</style>
